import { createMiddleware } from '@shared/redux';
import { match } from '@shared/utils/match';
import { LOCATION_CHANGE } from 'connected-react-router';
import { trackOnRudderStack } from '@domain/analytics';
import { PARTNERSHIPS_ROUTERS } from '@domain/partnerships';
import { CREATE_DOCUMENT } from '@domain/partnerships/partners/trakto';
import { PLATFORMS } from '@domain/platform';

export const traktoMiddleware = createMiddleware({
    [LOCATION_CHANGE]: match((_, action) => action.payload.location.pathname, {
        [PARTNERSHIPS_ROUTERS.TRAKTO]: () => {
            trackOnRudderStack('partnerships', { platform: PLATFORMS.TRAKTO.value, action: 'visit' });
        },
    }),
    [CREATE_DOCUMENT]: () => {
        trackOnRudderStack('partnerships', { platform: PLATFORMS.TRAKTO.value, action: 'create_document' });
    },
});
